import React from 'react';

import { Box, Popover, Typography, makeStyles } from '@material-ui/core';

import { MapPopoverProps } from '../GeoMap.proptypes';

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: 'none'
  },
  popoverContent: {
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.primary.main}`
  }
}));

const MapPopover = ({ element, name }: MapPopoverProps) => {
  const classes = useStyles();

  return (
    <Popover
      open={Boolean(element)}
      anchorEl={element}
      className={classes.popover}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
    >
      <Box className={classes.popoverContent}>
        <Typography>{name}</Typography>
      </Box>
    </Popover>
  );
};

export default MapPopover;
